import { render, staticRenderFns } from "./ai-check.vue?vue&type=template&id=e964268c"
import script from "./ai-check.vue?vue&type=script&lang=js"
export * from "./ai-check.vue?vue&type=script&lang=js"
import style0 from "./ai-check.vue?vue&type=style&index=0&id=e964268c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports